module.exports = {
  "FoodC_C_Detailed_rules_WfnL": "Como funciona",
  "FoodC_birthday_nxQg_feGV": "Usos restantes: {{n}}",
  "FoodC_unsubscription_moTV_YOeR": "Usaremos essa informação para melhorar nossos serviços de assinatura.",
  "FoodD_optimization_lXdy_Scjt": "Regras detalhadas",
  "FoodC_update_mXRF_lKCK": "Novo",
  "FoodC_update_YSxw_ZNzh": "Primeiro mês",
  "FoodC_saverpack_Vsih_jLbN": "{{n}} cupons usados",
  "FoodC_shoprank_OYFZ_jaot": "Regras detalhadas",
  "FoodC_subscription_uipE_quiy": "Voltar",
  "FoodD_Gattaran_gaJp_rKSK": "Veículo do indicador",
  "FoodC_membership_ootV_ZRYt": "Economize mais {{percent}} em comparação com uma assinatura mensal.",
  "FoodC_V2_kGDN_zGcg": "Ao se inscrever, você autoriza {{didifoodbrand}} a cobrar automaticamente {{money}} mensalmente a partir de {{date}}. Você pode cancelar a assinatura a qualquer momento sem taxas ou penalidades adicionais. {{rules}}",
  "FoodC_update_UDFM_jhpN": "Entrega grátis em todos os pedidos",
  "FoodC_store_Store_Coupon_szoR": "Cupons da loja",
  "FoodC_Task_Congratulations_pDXl": "Parabéns!",
  "FoodC_V2_RTeI_mEFs": "A partir de {{date}}, o valor de {{money}} será cobrado automaticamente por mês. Você pode cancelar sua assinatura a qualquer momento.",
  "FoodC_CGC_Other_channel_oFak": "Compartilhar por outro aplicativo",
  "FoodC_membership_ZQog_oSjJ": "Selecione um plano",
  "FoodC_membership_XTeP_nLeJ": "Semestral",
  "FoodC_Notifications_Invite_users_Ovxe": "Usuários convidados",
  "FoodC_C_Off_fkZy": "OFF",
  "FoodC_CGC_SaMA_ymHl": "Esta campanha destina-se apenas a pedidos na {{app_name}} pagos online e as recompensas não podem ser sacadas ou transferidas",
  "FoodC_birthday_UhuO_lUDL": "Não foi possível resgatar os cupons. Tente novamente mais tarde",
  "FoodOpB_account_Loading_EDDu": "Carregando",
  "FoodC_CGC_XBGw_UVvR": "Os amigos que você convidar devem ser qualificados de acordo com as regras da campanha da {{app_name}}. Cada usuário tem direito a aproveitar a recompensa apenas {{num}} vez(es). Usuários com o mesmo número de celular, dispositivo ou conta de pagamento serão considerados o mesmo usuário",
  "FoodC_subscription_skWN_HfEE": "Renovação automática",
  "FoodC_update_QQlM_iHYO": "Configurações",
  "FoodC_side3_xeOS_SWLO": "Disponível para {{name}}",
  "FoodC_pause_iXVD_owuh": "Sua assinatura da {{brand}} será retomada automaticamente após o término da pausa e você será cobrado(a) em {{money}} em {{date}}. {{tc}}",
  "FoodC_unsubscription_tNxS_UdhI": "Selecione o motivo",
  "FoodD_Gattaran_KYAP_kQnV": "1. Convite amigos para se cadastrarem",
  "FoodC_pause_Wukv_RhXR": "Pausar cobranças automáticas",
  "FoodC_subscription_StNY_sWmE": "Ao enviar o pagamento, você concorda com os {{rules}}.",
  "FoodB_V2_dLkl_pbiF": "Para executar essa ação, atualize para a versão mais recente do aplicativo",
  "FoodC_membership_dmqk_wJgV": "Trimestral",
  "FoodC_V1_Gift_box_UWqz": "Você já abriu esse presente",
  "FoodC_C_Mission_completed_FkCw": "Tarefa concluída",
  "FoodC_saverpack_hgwE_EIDA": "Comprado",
  "FoodC_url_reaV_LXaO": "Usar agora",
  "FoodC_update_wBxB_qtoB": "Inscreva-se na {{brand2}} e aproveite seu primeiro mês grátis. Você autorizará a {{didifoodbrand}} a cobrar automaticamente {{money1}}/mês pelos próximos dois meses e {{money2}}/mês a cada mês seguinte. Você pode cancelar a inscrição a qualquer momento, sem taxas ou implicações adicionais. {{rules}}",
  "FoodD_Activity_Completed_tPlA": "Concluído",
  "FoodC_membership_fBAi_MQrN": "Mensal",
  "FoodC_update_VNPd_BxNP": "Upgrade gratuito para a {{brand1}}",
  "FoodC_CGC_qcLp_cjum": "Esta campanha está disponível apenas em áreas selecionadas nas quais a campanha da {{app_name}} for oferecida, incluindo: {{city_list}}",
  "FoodC_details_The_following_bPLC": "Disponível nas seguintes lojas",
  "FoodC_c_Please_try_cHSE": "Tente novamente mais tarde",
  "FoodC_C_View_Coupon_OIhv": "Ver cupons",
  "FoodC_1_Maximum_number_cJPy": "Limite diário atingido",
  "FoodC_C_Received_DOQd": "Resgatado",
  "FoodC_pause_izJa_kTkD": "Deseja pausar as cobranças automáticas?",
  "FoodC_homepage_Unable_to_ybHC": "Localização não encontrada",
  "FoodC_CGC_KVtY_VNSE": "Convide amigos para fazer pedidos na {{app_name}}. Se seu amigo reivindicar um cupom compartilhado por você e concluir um pedido sem solicitar um reembolso antes do término do evento, você receberá um cupom da {{amount}} como recompensa, independentemente de o cupom reivindicado ser usado ou não.",
  "FoodC_membership_Kgjx_NwXL": "Ativar assinatura trimestral",
  "FoodC_subscription_uwdO_LCcw": "Pacote Booster",
  "FoodD_optimization_Wiuc_vkvD": "Convidar um(a) amigo(a)",
  "soda-d-i18n---奖励详情": "Detalhes da recompensa",
  "FoodC_2_Enter_mobile_jXbU": "Inserir número de telefone",
  "FoodC_register_cCpr_KUUG": "Falha no pagamento",
  "FoodC_words_vHza_gIgE": "Participe da {{brand}} por {{money}}/mês",
  "FoodC_C_No_coupon_DlRu": "Não há pacotes de cupons disponíveis",
  "FoodC_demand_Courier_purchasing_vPGD": "Compra: parceiro",
  "FoodC_membership_SyjM_DiMe": "Economize {{percent}} por mês",
  "FoodC_update_faXs_YHbq": "Participando desde",
  "FoodC_words_TYXi_ntMY": "Depois, {{money}}/mês",
  "FoodC_CGC_WOQY_zerr": "O número de celular do destinatário usado para receber pedidos deve ser igual ao número de celular usado para registro do perfil e resgate de cupons.",
  "FoodC_unsubscription_EyKD_bpPY": "Continuar usando a {{brand}}",
  "FoodC_update_KTVU_dCMP": "Ilimitado",
  "soda-d-i18n---没有更多了": "Sem mais resultados",
  "FoodC_V2_RUXY_aLKJ": "Forma de pagamento automática",
  "FoodC_Notifications_Congratulations_you_qoKt": "Você recebeu uma recompensa",
  "FoodC_page_Your_invited_sPpR": "O amigo que você convidou deve ser um cliente novo da {{\t\nproductname_didi_food}}. Descontos no primeiro pedido são limitados a um por cliente (cada cliente deve ter um único número de telefone, dispositivo e conta para pagamento)",
  "FoodC_update_QaEe_FhNn": "{{money}}/mês",
  "FoodC_C_Mission_Centre_HafM": "Central de tarefas",
  "FoodC_subscription_CYiq_FQpm": "Preço: {{money}}",
  "FoodC_page_Rewards_are_dWeY": "A recompensa é emitida com base na cidade em que a [pessoa indicada] está localizada",
  "FoodC_C_Purchased_YheA": "Comprado",
  "FoodC_membership_yQRX_Opwv": "Sua assinatura mensal atual é válida até {{date1}}, e a assinatura trimestral começará em {{date2}}. Você pagará {{money}} automaticamente a partir de {{date3}} referente a assinatura do próximo trimestre. Você pode cancelar a qualquer momento gratuitamente.",
  "FoodC_saverpack_VKyf_NHhh": "Compre por {{money}}",
  "FoodC_update_HXID_CLBi": "Histórico de compras",
  "FoodC_update_WqVL_CaFf": "Mais vantagens",
  "FoodC_register_qELy_skhp": "Tente outra forma de pagamento",
  "FoodC_membership_SafL_QGjc": "Você pagará {{money1}} agora. Sua assinatura mensal atual é válida até {{date1}}, e a assinatura anual começará em {{date2}}. Você pagará {{money2}} automaticamente a partir de {{date3}} referente a assinatura do próximo ano. Você pode cancelar a qualquer momento gratuitamente.",
  "FoodC_rule_14_Up_dovx": "Limite de dois cupons por cliente por dia",
  "FoodC_C_Available_DlSP": "Disponível",
  "sailing.d-api.common.活动时间": "Horário do evento",
  "FoodC_update_PJJg_EEDD": "Próximos 2 meses",
  "FoodOpC_city_Rewards_are_oURm": "A recompensa é emitida com base na cidade em que a [Pessoa Indicada] está localizada",
  "FoodC_C_You_will_FoTj": "Você receberá",
  "FoodC_page_The_threshold_yZFq": "Os limites de uso e os períodos de validade são exibidos nos cupons. Os cupons só podem ser usados durante o período de validade",
  "FoodC_c_Sign_in_gRWz": "Entrar",
  "FoodC_Translation__brand_LAYp": "Cupons {{brand_name}}",
  "FoodC_update_UnpB_Dwqt": "Data da retomada",
  "FoodC_membership_iIPB_XJQE": "Parabéns por se inscrever para uma assinatura semestral! Sua assinatura entrará em vigor em {{date}}.",
  "FoodC_membership_bNzP_hekS": "Ativar assinatura semestral",
  "sailing.d-api.common.以上活动最终解释权归滴滴外卖所有": "A 99Food reserva-se o direito final de interpretação dos eventos descritos acima",
  "FoodC_update_KqNE_JARP": "Use a {{brand1}} grátis por 30 dias",
  "FoodC_subscription_gNZb_xfcd": "Cancelar a assinatura de {{didipackbrand}}",
  "FoodC_page_XCBA_oZij": "pedidos",
  "sailing.c-api-intl.超出配送范围": "Fora da área de entrega",
  "FoodC_update_ErLg_Lrtz": "Expirado",
  "FoodC_birthday_uoAk_Rmzj": "Toque aqui para ver seus cupons",
  "FoodC_unsubscription_xxOV_zoQL": "Por que você quer cancelar sua assinatura?",
  "FoodC_saverpack_FDoL_prPs": "Experimente",
  "FoodD_2_Single_amount_LbPB": "Pedidos",
  "FoodD_optimization_WVNI_kCwK": "{{day}} dia(s) {{hour}} hora(s) restante para o convite",
  "FoodC_C_No_suitable_UnyN": "No momento não há ofertas disponíveis",
  "FoodC_membership_mteQ_ejcJ": "{{money}}/mês",
  "FoodC_membership_SrhP_uair": "Parabéns por se inscrever para uma assinatura trimestral! Sua assinatura entrará em vigor em {{date}}.",
  "FoodC_subscription_JZaZ_ToBk": "Somente {{money1}} no primeiro mês para se inscrever na {{didipackbrand}}. Você autoriza a {{didifoodbrand}} a cobrar automaticamente {{money2}} de você no mês seguinte. Você pode cancelar a assinatura a qualquer momento sem taxas ou multas adicionais.",
  "FoodC_V2_ryoa_JKea": "Adicionar uma forma de pagamento",
  "FoodC_pause_LiWX_icgn": "Sua assinatura foi retomada.",
  "FoodC_membership_fbbI_fyYa": "Sua assinatura é válida até {{date1}}. A {{brand}} cobrará {{money}} automaticamente em {{date2}} para renovar sua assinatura para o próximo trimestre. Você pode cancelar a qualquer momento gratuitamente.",
  "FoodC_pause_pfAh_qUrD": "Pausar cobranças",
  "FoodD_Gattaran_YoUy_yxOy": "3. Ganhe recompensas",
  "FoodC_C_Purchase_Records_CIUH": "Histórico",
  "FoodC_membership_tOCk_ZLUS": "Ativar assinatura trimestral",
  "FoodC_subscription_arhI_yUex": "Manter meus benefícios",
  "FoodC_pause_xeiI_PONf": "Agora não",
  "FoodC_membership_tatd_NykT": "Sua assinatura mensal atual é válida até {{date1}}, e a assinatura anual começará em {{date2}}. Você pagará {{money}} automaticamente a partir de {{date3}} referente a assinatura do próximo ano. Você pode cancelar a qualquer momento gratuitamente.",
  "FoodC_birthday_mwOE_zhiz": "Entendi",
  "FoodC_membership_KBOw_KYHp": "Você pagará {{money1}} agora. Sua assinatura mensal atual é válida até {{date1}}, e a assinatura trimestral começará em {{date2}}. Você pagará {{money2}} automaticamente a partir de {{date3}} referente a assinatura do próximo trimestre. Você pode cancelar a qualquer momento gratuitamente.",
  "FoodC_pause_AtFL_nncW": "Assinatura pausada",
  "FoodC_didipack_XQlZ_sNjR": "Somente {{money1}} no primeiro mês para se inscrever na {{didipackbrand}}. Você autoriza a {{didifoodbrand}} a cobrar automaticamente {{money2}} de você no mês seguinte. Você pode cancelar a assinatura a qualquer momento.",
  "FoodC_update_FzRU_BQMG": "Pausado",
  "FoodC_birthday_bthp_qePu": "Confirmar",
  "FoodD_optimization_jCaj_SrWJ": "Não há ações de recompensa ativas na cidade atual",
  "FoodC_c_Login_for_puGR": "Entre para ver mais informações",
  "FoodC_C_Coupon_Purchase_zdkl": "Histórico de compras",
  "FoodC_pause_cYix_reoR": "As cobranças da {{brand}} serão pausadas em {{date}}. Enquanto sua assinatura estiver pausada, nenhum valor cobrado e você não receberá nenhuma vantagem.",
  "FoodC_1_qiwJ_ERdV": "Linked successfully",
  "FoodC_C_Payment_money_XOtx": "Comprar por {{money}}",
  "FoodC_C_Buy_again_ScTm": "Pode ser comprado novamente em {{countdown}}",
  "FoodC_update_mBwf_uAvp": "Começar a economizar",
  "FoodC_button_Download_DUuD": "Baixar {{product_name}}",
  "FoodC_update_ZFGk_VVRa": "Ver detalhes",
  "FoodC_CGC_Copy_MtAU": "Copiar",
  "FoodC_pause_NJOj_iqnX": "A assinatura está pausada.",
  "FoodD_Activity_Single_Step_xtWh": "Recompensa por volume de pedido",
  "FoodC_update_TXai_tCJL": "Parabéns por se juntar à {{brand}}",
  "FoodC_membership_dfUx_OawR": "Ativar assinatura anual",
  "FoodC_update_BIRW_NftU": "Use a {{brand1}} grátis por 30 dias (Upgrade da {{brand2}})",
  "FoodC_Notifications_Invite_successful_RBjt": "Convites realizados",
  "FoodC_C_Time_of_LACt": "Hora da compra",
  "FoodC_V2_RlIh_OuIP": "Forma de pagamento",
  "FoodC_page_ZTLT_FASC": "Sem cupons? Obtenha mais vantagens de entrega gratuita aqui",
  "FoodC_birthday_teJB_YsTQ": "Aniversário: {{date}}",
  "FoodC_birthday_lxme_nZrh": "Cadastre seu aniversário",
  "FoodC_C_Go_tdhw": "Solicitar agora",
  "soda-m-i18n---奖励规则": "Regras da recompensa",
  "FoodC_shoprank_Qwab_yWBb": "Entendi",
  "FoodC_membership_AeuK_Curt": "Ativação pendente",
  "FoodC_CGC_Cruel_departure_Smts": "Agora não",
  "FoodC_Promotions_hkSD_CMsv": "Termos e Condições",
  "FoodC_C_Buy_again_iOeQ": "Compre novamente em {{day}} dias",
  "FoodC_C_Unlimited_store_Ujro": "Aproveite esta oferta e economize {{money}} com as taxas de entrega em seus próximos pedidos!",
  "FoodC_register_mezq_UlpA": "Entendi",
  "FoodC_words_ikBq_XDxq": "Participe da {{brand}} por {{money}}",
  "FoodD_Activity_In_progress_NrnP": "Ativo",
  "FoodC_1_Coupon_received_EEkp": "Nenhum cupom",
  "FoodC_update_pgdT_nUsj": "Economia média de {{money}}",
  "FoodC_C_No_coupon_JTJL": "Não há pacotes de cupons disponíveis para compra",
  "FoodC_CGC_Go_and_fnbj": "Resgatar agora",
  "FoodC_V2_SvHk_RdVM": "Parabéns! Você se inscreveu em {{didipackbrand}}",
  "FoodD_Gattaran_BWwg_jeOR": "Você receberá recompensas assim que seus amigos concluírem uma tarefa",
  "FoodD_optimization_MkEn_uAUM": "Tente trocar de cidade",
  "FoodC_Task_Successfully_received_jXDz": "Você recebeu {{coupon}} cupom(ns)",
  "FoodC_membership_nksN_IHwY": "Cobrança de {{money}}/ano",
  "FoodC_saverpack_wepe_hxUg": "Pode ser comprado novamente em {{n}} dias",
  "FoodC_1_Coupon_Account_kcLB": "Perfil atual: {{phone_number}}",
  "DiDi_Food_(C)_Suspended_Delivery_status_Delivery_Pause_PIPS": "Indispon. no momento.",
  "FoodC_membership_sKhv_iXXm": "Recomendado",
  "FoodC_C_Collection_rqwP": "Resgatar",
  "FoodC_subscription_LiqM_lRQw": "99 Club",
  "FoodC_V1_Click_receive_fBbu": "Resgatar agora",
  "FoodC_CGC_kRMT_EBEL": "Qualquer amigo que você convidar deve fazer um pedido na {{app_name}}. As recompensas não serão emitidas por pedidos realizados por outros canais",
  "FoodC_C_Universal_Coupon_qLGm": "Cupom universal",
  "FoodC_C_Used_tgaq": "Usado",
  "FoodC_C_Only_money_ZEKz": "Pague apenas {{money}}",
  "FoodC_CGC_QXwb_BKmD": "Período da campanha: {{startdate}} a {{enddate}}",
  "sailing.d-api.common.如何获得奖励": "Como receber recompensas",
  "FoodC_member_qXYs_kKZA": "Entendi",
  "FoodOpC_Notifications_Full_service_HBkd": "Todas as cidades",
  "FoodC_membership_hDlN_ORJH": "Pague {{money1}} no primeiro mês e depois {{money2}}/mês",
  "FoodC_C_Expired_AEpg": "Expirado",
  "FoodB_Part2_Detailed_description_mxuF": "Detalhes",
  "FoodC_CGC__name_Mjiz": "{{name}} ganhou um desconto de {{x}}",
  "FoodC_update_AxFi_uOud": "Período de pausa",
  "FoodC_1_zbTm_gzFe": "Unlink",
  "FoodC_CGC_Invite_immediately_dQRx": "Enviar convite",
  "FoodC_241106_qWoj_Vqkc": "Você recebeu {{n}} meses gratuitos de assinatura da {{brand}}.",
  "FoodB_supplement_Network_connection_RVcl": "Falha na conexão. Verifique suas configurações de rede",
  "FoodC_membership_yygL_TGwF": "Parabéns por se inscrever para uma assinatura anual! Sua assinatura entrará em vigor em {{date}}.",
  "FoodC_membership_uAos_hrFr": "Cobrança de {{money}}/trimestre",
  "FoodC_page_Rewards_will_NhMd": "Sua recompensa será adicionada ao seu perfil até 48 horas após uma indicação bem-sucedida. Para ver as recompensas, acesse {{\t\nproductname_didi_food}} > Carteira > Cupons",
  "FoodC_subscription_pODC_SAYm": "Expirado",
  "FoodC_membership_iRFJ_WWfs": "Sua assinatura é válida até {{date1}}. A {{brand}} cobrará {{money}} automaticamente em {{date2}} para renovar sua assinatura para o próximo ano. Você pode cancelar a qualquer momento gratuitamente.",
  "FoodC_name_99_Takeaway_GFhX": "99Food",
  "FoodC_Notifications__end_QQPI": "Termina em {{end_time}} dias",
  "FoodC_1_AeFt_EzNz": "Cancel",
  "FoodC_page_Upon_discovery_baTq": "O cupom não pode ser trocado ou resgatado em dinheiro. A violação das regras do cupons pode resultar na recuperação do valor e na suspensão do perfil",
  "FoodC_C_To_be_Qemy": "Disponível",
  "FoodC_V2_syWI_awMo": "Cartão de débito/crédito",
  "FoodC_CGC_gLdR_yRZb": "Se qualquer violação ou atividade de saque for constatada, o valor relevante será recuperado ou o perfil será suspenso, e todas responsabilidades legais serão aplicadas de acordo com a lei.",
  "FoodC_button_Open_fmKT": "Abrir {{product_name}}",
  "FoodC_update_pkbs_cuBj": "Sua assinatura {{brand}} termina em {{date}}",
  "FoodC_membership_Pmws_DJul": "Você autorizará a {{brand}} a cobrar automaticamente {{money}} por trimestre a partir de {{date}}. Você poderá cancelar a assinatura a qualquer momento sem taxas ou penalidades adicionais.",
  "FoodD_Activity_Rewards_will_TMCp": "As recompensas são calculadas após o término do evento",
  "FoodC_subscription_YJLt_vjMk": "Participar da {{didipackbrand}}",
  "FoodC_birthday_JshR_FWPW": "A data não pode ser modificada depois de cadastrada",
  "sailing.d-api.common.条款和条件": "Termos e Condições",
  "FoodB_20230410_YNjt_xAWA": "DiDi Top",
  "FoodC_birthday_ZEpi_KbUs": "Resgate de cupons concluído",
  "FoodC_pause_VaEr_OWMS": "Assinatura pausada",
  "FoodC_didipack_uwFV_TgLK": "Torne-se um membro e economize {{money}}/mês",
  "FoodC_coupons_Congratulations_on_YevG": "Parabéns! Você recebeu um cupom",
  "FoodC_Notifications_Invite_user_GtIH": "Convide mais {{user_num}} usuários e receba {{gift}}",
  "FoodC_words_MBwE_Wmhg": "{{money}} no primeiro mês",
  "FoodC_birthday_hJRO_UaMS": "Resgatar cupons de aniversário",
  "soda-b-web-i18n---休息中": "Fechar",
  "FoodC_invite_Step_2_AhBV": "Etapa 2: O novo usuário se cadastra e faz um pedido",
  "FoodC_update_SekQ_qUvj": "Taxa da assinatura",
  "FoodC_subscription_RApp_AMMC": "Ao comprar {{didipackbrand}}, você concorda com as {{rules}}. Você pagará {{money}} no dia de cobrança de cada mês. Você pode cancelar a assinatura gratuitamente a qualquer momento.",
  "FoodC_Notifications_Congratulations_gTCr": "Parabéns!",
  "sailing.banner-intl.暂停营业": "Temporariamente encerrada",
  "FoodC_CGC_xGpr_jdrf": "Se você tem dúvidas sobre esta campanha, entre em contato com o Atendimento ao Cliente {{app_name}}",
  "FoodC_1_Receiving_Records_RumV": "Histórico de recompensa",
  "FoodC_unsubscription_oSsY_xaBg": "Conte-nos mais (Opcional)",
  "FoodC_page_Invite_friends_oGuj": "Convide um amigo para experimentar a {{\t\nproductname_didi_food}}. Você também receberá um [cupom] de{{\t\nproductname_didi_food}} caso seu amigo faça um pedido completo, sem pedido de reembolso, no prazo de até 14 dias após o recebimento do convite e antes do cupom expirar, mesmo se o cupom não for utilizado no pedido",
  "FoodC_invite_Step_3_VjuY": "Etapa 3: Ganhe recompensas",
  "FoodC_subscription_CtEg_IEoy": "Cancelar a assinatura de {{didipackbrand}}",
  "FoodC_C_You_will_pQqU": "Você receberá {{n}} cupons",
  "FoodC_subscription_yHJx_Ospz": "Período de validade: {{date1}} a {{date2}}",
  "FoodC_C_Coupon_Center_WghP": "Central de pacote de cupons",
  "FoodC_1_Unable_to_yqfz": "Não é possível solicitar",
  "FoodC_V1_Use_IuaW": "Usar agora",
  "FoodC_page_This_special_fYuo": "Essa promoção é oferecida somente em áreas de {{\t\nactivity_city}} onde {{\t\nproductname_didi_food}} está disponível.",
  "FoodC_page_For_any_IWNZ": "Para esclarecer dúvidas sobre essa promoção, entre em contato com o Atendimento ao Cliente em {{contact_email}}",
  "FoodC_update_RaYq_YNqC": "Informações da assinatura",
  "FoodD_Activity_Expand_more_VNNc": "Mostrar mais",
  "FoodC_words_bshC_QpQz": "Participe da {{brand}} por {{money}} no primeiro mês",
  "FoodC_unsubscription_PWOD_DyeO": "Você se inscreveu com sucesso.",
  "FoodC_C_Terms_and_eAhU": "Termos e Condições",
  "FoodC_saverpack_GjXC_jBNu": "{{n}} cupons disponíveis",
  "FoodC_membership_BIGZ_CvrZ": "Anual",
  "FoodC_pause_aidJ_DeYv": "Sua assinatura foi cancelada.",
  "FoodC_membership_StFc_NVHY": "Sua assinatura mensal atual é válida até {{date1}}, e a assinatura semestral começará em {{date2}}. Você pagará {{money}} automaticamente a partir de {{date3}} referente a assinatura do próximo semestre. Você pode cancelar a qualquer momento gratuitamente.",
  "FoodC_update_lgoe_CKtm": "Grátis",
  "FoodC_C_Invitation_CPGR": "Convidar",
  "FoodC_membership_MEEh_ctts": "Ativar assinatura anual",
  "FoodC_c_Please_log_pWNK": "Entre em seu perfil",
  "FoodC_subscription_eceZ_mHfd": "Você pagará automaticamente {{money}} em {{date}}. Você pode cancelar a assinatura a qualquer momento sem taxas ou multas adicionais.",
  "FoodD_optimization_KHwe_UDpu": "Ver tudo",
  "FoodC_didipack_kIYJ_MqHw": "Você autoriza a {{didifoodbrand}} a cobrar automaticamente {{money2}} de você no mês seguinte. Você pode cancelar a assinatura a qualquer momento.",
  "FoodC_invite_Step_1_IIde": "Etapa 1: Convide um novo usuário",
  "FoodC_V1_View_activity_NCOP": "Ver outros eventos",
  "FoodD_Gattaran_Tfhf_xZxX": "Compartilhe seu link de convite com amigos ou peça ao convidado para inserir seu código ao se cadastrar. O indicado deve concluir o cadastro antes do prazo e atender a todos os requisitos de qualificação para participar.",
  "FoodC_1_tSXl_EXCL": "Link Account",
  "FoodD_Activity_Number_of_vXPs": "Recompensa por pessoas indicadas",
  "FoodC_c_Unable_to_cPrS": "Serviço indisponível",
  "FoodC_C_Back_Home_opQY": "Ir para o início",
  "FoodD_optimization_Qqcn_TvQv": "Sem convites. Veja o Histórico",
  "FoodD_optimization_pADD_hRLc": "Outras opções de convite",
  "FoodC_copyaddJP_Your_mobile_zrXT": "Não se preocupe, seu número só será usado no resgate do seu cupom do evento. Ao colocá-lo, você permite que a 99Food envie o resgate do cupom para o seu número.",
  "FoodC_member_wEQc_Appv": "Você já selecionou a {{brand}} para compra como parte do seu pedido atual. Apenas conclua seu pedido para se tornar um membro.",
  "FoodC_membership_Cmcr_KOyO": "Ativar assinatura semestral",
  "FoodC_Notifications_Rewards_received_czXX": "Recompensas recebidas",
  "sailing.d-api.common.其他说明": "Outras observações",
  "FoodC_membership_aBDt_VhkX": "Sua assinatura é válida até {{date1}}. A {{brand}} cobrará {{money}} automaticamente em {{date2}} para renovar sua assinatura para o próximo semestre. Você pode cancelar a qualquer momento gratuitamente.",
  "soda-m-i18n---完成": "Concluído",
  "FoodC_all_You_haven_lSmt": "Você ainda não convidou nenhum amigo. Convide alguém",
  "FoodC_Notifications_Accept_the_wTgP": "Convite aceito",
  "FoodC_1_UGRq_VTHx": "Enter your membership account",
  "FoodC_pause_dEKK_qnxf": "As cobranças automáticas da sua assinatura foram pausadas e suas vantagens ficarão indisponíveis por {{num}} mês(es) começando em {{date1}}. Sua assinatura da {{brand}} será retomada em {{date2}} e você será automaticamente cobrado(a) em {{money}}. {{tc}}",
  "FoodC_subscription_KlqY_fMjr": "Válido",
  "FoodC_member_fKsy_UJNP": "Ver pedido",
  "FoodC_C_Use_jLVF": "Usar",
  "FoodC_birthday_MdbO_KlNx": "Inserir aniversário",
  "FoodC_C__n_tBvE": "Cupons da {{n}}",
  "FoodC_campaign_RqSl_PwEk": "Esta oferta destina-se apenas a pedidos na {{99Food}} e as recompensas não podem ser sacadas nem transferidas.",
  "FoodD_optimization_rIEQ_UWUa": "Compartilhar",
  "FoodD_Gattaran_jMrz_rmga": "2. O indicado conclui pedidos",
  "FoodC_C_Maximum_deduction_UvNt": "Até {{money}} OFF",
  "FoodC_CGC_There_is_gZQn": "Você ainda tem {{x}} para resgatar",
  "FoodC_update_PQxd_TDOz": "Junte-se à {{brand}} e faça um pedido para começar a economizar dinheiro.",
  "FoodC_member_rIZz_EbdA": "Você já está adquirindo uma assinatura",
  "FoodC_CGC_JFyK_TjqE": "Os limites de uso e os períodos de validade são exibidos nos cupons. Os cupons só podem ser usados durante o período de validade",
  "FoodC_subscription_XfQl_RWPP": "Assinatura",
  "FoodC_saverpack_DPys_ZTjB": "Regras",
  "FoodC_c_Try_again_lIZQ": "Tentar novamente",
  "FoodC_1_gJQN_sqIt": "Unlink Membership Account",
  "FoodC_unsubscription_qlCR_GqbU": "Cancelar assinatura",
  "FoodC_birthday_vcey_tequ": "Ver cupons",
  "FoodC_update_FOFJ_UkRW": "5% OFF em todas as corridas",
  "FoodC_membership_ghra_QaCb": "Você pagará {{money1}} agora. Sua assinatura mensal atual é válida até {{date1}}, e a assinatura semestral começará em {{date2}}. Você pagará {{money2}} automaticamente a partir de {{date3}} referente a assinatura do próximo semestre. Você pode cancelar a qualquer momento gratuitamente.",
  "FoodC_page_hbyT_BKde": "Entrega gratuita",
  "FoodC_C_Coupon_package_aeUS": "Pacote de cupons",
  "FoodC_subscription_HZKf_jObw": "Atualmente você não tem uma assinatura ativa",
  "FoodC_membership_CHIm_nRPw": "Cobrança de {{money}}/semestre",
  "FoodC_saverpack_slen_UJLn": "Receba {{n}} cupons e economize até {{money}}! Não é necessária assinatura.",
  "FoodD_optimization_hPwx_hGCS": "Histórico",
  "FoodC_subscription_Jnyy_Zokk": "Sua assinatura {{didipackbrand}} está sendo renovada. Volte mais tarde",
  "soda-m-i18n---取消": "Cancelar",
  "FoodC_C_More_TIyU": "Mais",
  "FoodC_campaign_aFBJ_ipZl": "As recompensas serão adicionadas ao seu perfil em até {{num}} hora(s) após a conclusão do processo de convite. Para ver os cupons, acesse a página da lista de cupons na {{99Food}}.",
  "FoodC_1_Additional_Surprise_bBNh": "Novos clientes ganham recompensas extras",
  "FoodC_C_Up_to_boqc": "--",
  "FoodC_V2_NigJ_XaWd": "Inscrever-se em {{didipackbrand}}",
  "FoodC_update_iSQF_topi": "Sem taxa de serviço em todos os pedidos",
  "FoodD_Gattaran_seSn_keOw": "Lembre seus amigos de concluir o número obrigatório de pedidos durante a janela de conclusão de tarefas",
  "FoodC_update_rJfl_rGTF": "Sem taxa de serviço",
  "FoodC_STORE_sDEb_djsn": "Classificação",
  "FoodC_subscription_Wlpe_bBkf": "Histórico",
  "sailing.act-api-intl.活动已经结束": "Ação encerrada",
  "FoodC_membership_WgGp_puVL": "Você autorizará a {{brand}} a cobrar automaticamente {{money}} por semestre a partir de {{date}}. Você poderá cancelar a assinatura a qualquer momento sem taxas ou penalidades adicionais.",
  "FoodC_419_zBRR_jLNF": "Sem pedido mínimo",
  "FoodC_C_No_purchase_cMRq": "Sem histórico de compras",
  "FoodC_C_Full_money_oqcE": "Pedidos acima de {{money}}",
  "FoodC_update_fIEP_oDcY": "Upgrade",
  "FoodC_unsubscription_tnHb_xMuO": "Avançar",
  "FoodC_C_You_have_EjAA": "Você recebeu",
  "FoodC_update_ZTvS_WSTC": "Entrega grátis",
  "FoodD_Activity_No_activity_fhqd": "Sem histórico de recompensas",
  "FoodC_V2_qWhb_IjVg": "Inscrever-se",
  "FoodC_update_fyhl_EPiz": "Corridas com 5% OFF",
  "FoodC_didipack_ruhC_zsFU": "Participe do {{didipack}} por {{money}}",
  "FoodC_CGC_PFoL_QAIo": "Um cupom só pode ser usado quando o valor de um único pedido excede o valor limite do cupom. Apenas um cupom pode ser usado por pedido. Qualquer valor que exceda o desconto deverá ser pago pelo usuário",
  "FoodC_pause_qsCr_nszu": "Retomar assinatura",
  "FoodC_CGC_wkuZ_BrqU": "As recompensas são emitidas com base na cidade em que a [pessoa indicada] está localizada",
  "FoodC_register_WoRy_tjec": "Selecione um método de pagamento",
  "Gattaran_reffral_Kjwv_iVSZ": "Convidar amigos",
  "FoodC_Notifications_Completed_pEhY": "Concluído",
  "FoodC_cash_wnPC_qiCD": "Usar",
  "FoodC_update_VTVc_ZtNA": "Depois",
  "FoodC_C_Purchase_amount_RXkR": "Valor da compra",
  "FoodC_1_wrbv_ghhe": "Please enter a valid membership account",
  "FoodC_subscription_uoAf_TiHz": "Obrigado por usar a {{didipackbrand}}. Se você cancelar a inscrição, a assinatura da {{didipackbrand}} expirará em {{date}}. Tem certeza de que deseja cancelar a assinatura?",
  "FoodC_update_xiIf_xSte": "Informações básicas",
  "FoodC_C_Mission_expired_vxOU": "Não há tarefas disponíveis no momento",
  "FoodC_subscription_QaXu_EIIa": "Gerenciar {{didipackbrand}}",
  "FoodC_C_My_coupon_fmaV": "Meus cupons",
  "FoodC_V2_SSNq_tsZF": "Entendi",
  "FoodC_subscription_VPMP_seXT": "Regulamento",
  "FoodC_subscription_jyMF_Ybuq": "No momento, você está utilizando um teste gratuito da {{brand}}. Se você cancelar a assinatura agora, seu teste gratuito expirará imediatamente e você não terá direito à entrega gratuita de pedidos nem outras vantagens de membro.",
  "FoodC_1_biry_lDbX": "Successfully unlinked",
  "FoodC_C_Order_assignments_xxGZ": "Tarefa do pedido",
  "FoodC_subscription_DzKZ_WhvD": "Data da compra: {{date}}",
  "FoodC_1_Share_it_scKc": "Compartilhe para ganhar descontos!",
  "FoodD_Activity_Single_reward_ZrZS": "Recompensa por volume de pedido",
  "FoodC_CGC_has_successfully_CrTW": "{{x}} amigos convidados",
  "FoodC_update_TDwr_XZVd": "Minha {{brand2}}",
  "FoodC_update_LeTO_aqit": "Vantagens da assinatura",
  "FoodC_all_No_reward_ocGJ": "Não há recompensas",
  "FoodC_membership_urwF_ywDu": "Você autorizará a {{brand}} a cobrar automaticamente {{money}} por ano a partir de {{date}}. Você poderá cancelar a assinatura a qualquer momento sem taxas ou penalidades adicionais.",
  "FoodC_1_Everyone_is_Tdgu": "Todos estão recebendo recompensas",
  "FoodC_CGC_UFif_hfJM": "As recompensas serão enviadas para sua conta dentro de {{num}} hora(s) após um convite bem-sucedido. Você pode visualizar as recompensas acessando {{app_name}} > Carteira > Cupons",
  "FoodC_C_Go_VWzj": "Pedir agora",
  "FoodC_toast__SVYJ": "Oferta resgatada",
  "FoodC_C_The_end_yvSK": "Termina em",
  "FoodC_center_Ospi_SNsH": "Total economizado",
  "FoodC_page_eUPd_sDHg": "Regras",
  "sailing.d-api.common.活动疑问请联系": "Em caso de dúvida relacionada a algum evento, contate",
  "FoodD_Activity_Number_of_OgKt": "Recompensa por pessoas indicadas",
  "FoodC_pause_tfPj_IAoM": "Sua assinatura da {{brand}} será retomada em {{date}} e você será automaticamente cobrado(a) em {{money}}. {{tc}}",
  "soda-d-i18n---无任何记录": "Vazio",
  "FoodC_C_Bonded_package_lroO": "Loja de pacote de cupons",
  "当前无活动": "Nenhuma atividade atual",
  "该城市暂无活动": "No momento, não há ações nesta cidade",
  "取消": "Cancelar",
  "网络异常，请稍后再试": "Erro de conexão, tente novamente mais tarde",
  "手机号码错误": "Número de telefone inválido",
  "选择国家或地区": "Selecione o país ou a região",
  "暂时不需要%s的服务": "Serviço temporário não é necessário",
  "支付成功": "Pagamento bem sucedido",
  "我们正在努力": "Trabalhando nisso",
  "是，半年之内不要给我发邮件": "Tenho certeza, não me envie mais e-mails nos próximos 6 meses",
  "将优惠分享到": "Compartilhar promoção com",
  "邮件退订结果": "Resultado do cancelamento dos e-mails",
  "暂无活动": "Nenhuma ação disponível",
  "推荐记录": "Histórico de indicação",
  "恭喜你获得%s张优惠券，快去使用吧": "Parabéns! Você tem cupons de %s. Use-os para fazer o pedido",
  "X推D": "Indicação de X-D",
  "X推C": "Cliente indicado por X",
  "不支持现金支付": "Não suporta pagamentos em dinheiro",
  "该浏览器不支持自动复制": "Este navegador não aceita cópia automática",
  "对此类邮件不感兴趣": "Não tenho interesse nesse tipo de e-mail",
  "退订理由：": "Motivo do cancelamento da inscrição:",
  "登录": "Entrar",
  "输入手机号码获取优惠券": "Digite seu número de telefone e receba cupons!",
  "现金": "Dinheiro",
  "仅限%s": "%s",
  "规则详情": "Regras detalhadas",
  "您邀请的好友需通过%s下单，通过其他渠道下单不发放邀请奖励": "O amigo que você convidar precisa fazer um pedido pelo aplicativo %s. Pedidos feitos por outros canais não atenderão ao requisito para o recebimento de uma recompensa por convite",
  "折": "OFF",
  "是，再也不要给我发邮件了": "Tenho certeza, não me envie mais e-mails",
  "输入手机号": "Insira o número de telefone",
  "在这里购买！": "Compre aqui!",
  "阶梯奖励": "Recompensas em escala",
  "很遗憾，未能领取成功": "Desculpe! Não foi possível resgatar esta promoção",
  "活动时间": "Hora da promoção",
  "隐藏": "Ocultar",
  "%s可用": "Disponível em %s",
  "满%s可用": "acima de %s",
  "T&C": "Termos e Condições",
  "售罄": "Esgotado",
  "当前定位城市：": "Cidade atual definida:",
  "券包": "Pacote de cupons",
  "附近没有商家": "Não há estabelecimento próximos",
  "请登录": "Por favor, inicie sua sessão",
  "选择城市": "Selecione a cidade",
  "您已经成功领取优惠券": "Cupom recebido com sucesso",
  "兑换成功": "Resgatado",
  "更多详情": "Mais informações",
  "可获得%s优惠券": "Obter cupons de %s",
  "轻松来获得一个非常棒的优惠券包": "Fácil de obter um ótimo pacote de cupons",
  "请开启定位": "Ative o serviço de localização",
  "支付超时！": "O tempo limite do pagamento expirou!",
  "奖励会在邀请成功后的48小时内发放入您的账号，您可在%s-钱包-券中查看": "As recompensas serão enviadas à sua conta em até 48 horas após um convite bem-sucedido. Para vê-las, abra seu aplicativo %s e acesse “Carteira > Cupons”",
  "去升级": "Para atualizar",
  "复制成功": "Copiado",
  "免配送费": "Grátis",
  "重新加载": "Recarregar",
  "支付": "Pagar",
  "%s日内有效": "Válido por %s dias",
  "有效时间:": "válido até:",
  "当前无有效活动": "Sem promoções ativas",
  "周四": "Quinta-feira",
  "本优惠活动仅限%s[在线支付]的订单享受，不可提现转赠": "Esta promoção só está disponível para pedidos da %s [pagamento online]. Não é possível transferi-la ou trocá-la por dinheiro",
  "通过SNS邀请": "Compartilhar nas redes sociais",
  "分钟": "Min",
  "恭喜你！兑换成功！": "Parabéns! Cupom resgatado!",
  "优惠券中心": "Cupons do dia",
  "我的优惠券": "Meus cupons",
  "网络繁忙，请稍后再试": "Rede ocupada, tente novamente mais tarde",
  "很遗憾您无法接收我们的最新消息了，感谢您使用%s！": "Que pena que você não vai mais receber nossas mensagens. Agradecemos por usar a %s!",
  "奖励进度": "Progresso da recompensa",
  "领取成功": "Resgatado!",
  "周五": "Sexta-feira",
  "周二": "Terça-feira",
  "券包购买已超限制": "A compra do cupom excedeu o limite",
  "与": "and",
  "最高抵扣%s": "Desconto máximo de %s",
  "您邀请的好友必须是%s新用户，每人仅限享受1次新用户首单优惠，同一手机号、同一设备、同一支付账号视为同一用户": "O amigo que você convidar precisa ser um cliente novo da %s. Cada pessoa só pode receber um “Desconto de primeiro pedido para cliente novo”. O mesmo número de telefone, o mesmo dispositivo e a mesma conta para pagamento são considerados como o mesmo cliente",
  "邮件频率过高": "Os e-mails são muito frequentes",
  "收餐人手机号与领取券时输入的手机号和账号注册手机号必须为同一号码": "O número de telefone do destinatário do pedido, o número inserido após a reivindicação do cupom e o número usado para registrar a conta devem ser iguais",
  "当前手机系统不支持自动复制": "O sistema de celular atual não aceita cópia automática",
  "仅售": "Apenas",
  "兑换优惠券": "Resgatar cupom",
  "收起": "Ver menos",
  "大家都在领取奖励": "Todos estão recebendo recompensas",
  "配送费": "Taxa de entrega",
  "支付中": "Pagar",
  "在您的订单中使用这些优惠！": "Use estas ofertas em seu pedido!",
  "已获得奖励": "Recompensas ganhas",
  "SMS": "SMS",
  "恭喜你获得一张%s优惠券，快去使用吧": "Parabéns! Você tem um cupom de %s. Use-o para fazer o pedido",
  "复制": "Copiar",
  "我知道了": "Eu sei",
  "《法律声明与隐私政策》": "Termos de Uso e Política de Privacidade",
  "OFF": "OFF",
  "兑换中": "Em andamento",
  "周三": "Quarta-feira",
  "已参与过同类型活动</br>快去下单吧": "Você já participou de uma promoção parecida</br>Pode fazer o pedido!",
  "看看其他的活动": "Veja outras atividades",
  "周一": "Segunda-feira",
  "隐私政策》": "Privacy Policy",
  "推荐有奖": "Recompensas por indicação",
  "同意": "Concordo",
  "周日": "Domingo",
  "在购买后的一个月内都可以使用": "Disponível para uso dentro de um mês após a compra",
  "优惠券使用门槛及有效期详见券面提示，未在券有效期限内使用完毕的，不可继续使用": "O uso do cupom e os detalhes do período de validade são exibidos no próprio cupom. Não é possível usar cupons após o período de validade ",
  "邮件退订": "Cancelar o recebimento de e-mails",
  "输入兑换码": "Insira o código promocional",
  "详细规则": "Ver as regras da ação",
  "Share": "Compartilhar",
  "你已经打开过这个礼盒了": "Você já abriu esse presente",
  "知道了": "Entendi",
  "运营活动": "Promoção de operações",
  "定位服务未开启，需要先开启定位服务才能参与活动！": "Você só pode participar da ação com o serviço de localização ativado",
  "购买": "Comprar",
  "券账号：%s": "Perfil atual: %s",
  "查看其它活动": "Ver outros eventos",
  "新用户额外惊喜奖励": "Novos usuários têm mais desconto surpresa",
  "%s天后过期": "Expira em %s dias",
  "单笔订单金额满足优惠券使用门槛金额时方可使用，单笔订单只能使用一张优惠券，使用优惠后，如订单金额超出部分需用户自行支付": "É possível usar um cupom quando um pedido estiver dentro de seu valor limite. Só é possível usar um cupom por pedido. Qualquer quantia que ultrapasse o valor do cupom deverá ser paga pelo cliente",
  "可抵扣%s": "Aplicável para %s",
  "仅限%s使用": "Somente para %s",
  "领取记录": "Histórico de recompensa",
  "立即兑换": "Resgatar agora",
  "如果您退订邮件，可能会错过重要消息，您确定不再接收%s给您发送的邮件吗？": "Quando você cancela a inscrição, pode perder mensagens importantes. Quer mesmo parar de receber estes e-mails?",
  "周六": "Sábado",
  "待入账": "Pendente",
  "点击领取": "Resgatar agora",
  "落地页": "Landing page",
  "C运营弹窗": "Janela pop-up de Operações C",
  "POS": "Maquininha",
  "添加信用卡/借记卡": "Adicionar cartão de crédito / débito",
  "活动说明": "Descrições da ação",
  "Email": "E-mail",
  "领取失败": "Não é possível solicitar",
  "网络似乎存在问题，请稍后重试": "Parece que há um problema de rede, tente novamente mais tarde",
  "分享给朋友，一起享优惠吧！": "Compartilhe para ganhar descontos!",
  "《法律声明": "Termos de Uso",
  "当日有效": "Válido no dia",
  "有效期至": "válido até",
  "支付方式": "Forma de pagamento",
  "邀请": "Convidar",
  "等待支付结果": "Aguardando por resultados de pagamento...",
  "应付金额": "Valor do pagamento",
  "购买含4张$10mxn无门槛券的优惠券包仅需支付$20mxn": "Compre um pacote de cupons com 4 cupons ilimitados de US $ 10 milhões por apenas US $ 20 milhões",
  "是，一年之内不要给我发邮件": "Tenho certeza, não me envie mais e-mails nos próximos 12 meses",
  "仅限新用户使用": "Somente para novo cliente",
  "一经发现任何违规、套现行为，将追回相关金额或者封停账号，且依法追究其法律责任": "Qualquer violação das regras ou tentativa de descontar um cupom pode resultar na dedução da quantia em questão ou na suspensão da conta. Os responsáveis pela violação também podem ser implicados juridicamente",
  "退订": "Cancelar assinatura",
  "网络不佳，请检查您的网络": "Problemas na conexão, verifique sua conexão de rede",
  "重试": "Tente novamente",
  "查看更多": "Ver",
  "请选择支付方式": "Selecione uma forma de pagamento",
  "%s 人": "%s Pessoa",
  "我的邀请码": "Meu código de indicação exclusivo",
  "获取优惠券": "Obter cupons",
  "我的奖励": "Minhas recompensas",
  "C端落地页": "Landing page da 99Food",
  "兑换失败": "Não foi possível resgatar",
  "待入账奖励": "Recompensas pendentes",
  "加载失败": "Não é possível carregar",
  "必须同意用户条款，才能继续下一步": "Você precisa concordar com os Termos de Uso para prosseguir",
  "附近商家": "Estabelecimentos próximos",
  "暂无优惠券": "Nenhum cupom",
  "卡类型": "Tipo de cartão",
  "格式不正确": "Formato incorreto",
  "订单": "Pedido",
  "不可用原因": "Motivo inválido",
  "请您升级到最新的APP版本，体验外卖功能": "Atualize para a versão mais recente do APP para experimentar a função de take-away",
  "邀请一个好友即可获得": "Convide um amigo para ganhar cupons",
  "返回首页": "Ir para o início",
  "没有更多了": "Fim dos resultados",
  "去预订食物": "Ir para reservar comida",
  "More": "Mais",
  "有效期至%s": "Válido até: %s",
  "去看看": "Ir para o início",
  "兑换失败，请再试一次": "Erro. Tente novamente",
  "确认": "Confirmar",
  "已过期": "Expirado",
  "本优惠活动仅限[%s]开通%s区域": "Esta promoção só está disponível em áreas em [%s] onde a %s estiver disponível",
  "此活动尚未在您的城市开通": "Ação ainda não disponível em sua cidade",
  "确定": "OK",
  "去使用": "Usar agora",
  "%s": "%s",
  "当天过期": "válido por hoje",
  "去看看其他的": "confira outras promoções",
  "具体活动规则见": "Para mais detalhes, consulte o Regulamento",
  "条款和条件": "termos e Condições",
  "配送": "Entrega",
  "为你的第一单领取优惠": "Obter desconto para o seu primeiro pedido",
  "通用支付": "Todos os tipos de pagamento",
  "99Pay-余额": "99Pay - Saldo",
  "券被领完": "Nenhum cupom",
  "卡": "Cartão",
  "优惠券已放入": "Cupom enviado",
  "关于本活动的任何问题，请联系%s客服": "Se você tiver dúvidas sobre esta promoção, entre em contato com o serviço de Atendimento ao Cliente da %s no número ",
  "邀请好友成为%s新用户，好友领取您送出的红包，并在活动时间截止前完成订单且无退款，无论是否使用领取的红包下单，您均可获得%s[优惠券]奖励": "Convide um amigo para que ele se torne um novo cliente %s e possa resgatar um cupom enviado por você. Se ele fizer um pedido antes do término da promoção e não pedir o reembolso (ele pode usar seu cupom ao fazer o pedido ou não), você pode receber %s [Cupons] Recompensas",
  "推荐骑手": "Indicar parceiros",
  "活动已结束": "Esta ação foi encerrada",
  "今日领取次数达上限": "Limite diário atingido",
  "FoodC_bill_VODO_nrnN": "Total savings",
  "FoodC_cancellation_dfmf_HEyK": "Are you sure you want to cancel your membership in {{conuntry}}?",
  "FoodC_cancellation_GzWi_eKHb": "Subscription cancelled",
  "FoodC_bill_QiYn_xBng": "Savings Snapshot",
  "FoodC_bill_Bspm_MYZN": "Place an order now to enjoy your first membership discount",
  "FoodC_bill_xdYa_VuVu": "The orders below do not include membership discounts added today",
  "FoodC_cancellation_ulUw_bpyg": "Manage Membership in Other Countries",
  "FoodC_landingpage_hhPh_bwJS": "Unable to copy. Please try again",
  "FoodC_bill_DRvJ_yzMg": "Entrega",
  "FoodC_cancellation_ivLi_DstK": "Unsubscribed",
  "FoodC_bill_dUjM_rVQW": "Order Now",
  "FoodC_bill_jWTz_UdyX": "Shop",
  "FoodC_cancellation_Ezrs_LhQu": "Membership Under Development",
  "FoodC_landingpage_WjPA_dhTE": "Copied successfully",
  "FoodC_landingpage_dTIE_JZwU": "Copy the link and open it in your browser to claim your Spotify membership",
  "FoodC_cancellation_ChTe_NHPP": "{{days}} day(s) left",
  "FoodC_bill_qjez_JBnr": "Ride",
  "FoodC_cancellation_kNom_uYlR": "Subscribed",
  "FoodC_cancellation_hxiG_guHC": "Subscription paused",
  "FoodC_bill_MFfk_WhCz": "Saved",
  "FoodC_landingpage_mibx_wmgS": "Copy",
  "FoodC_cancellation_NLzA_tDER": "Membership isn't available in your country yet. Thanks for your interest and support.",
  "FoodC_bill_zfEm_MWKg": "Food",
  "FoodC_cancellation_JZXv_OcQW": "Unsubscribe"
}